module.exports = __webpack_public_path__ + "media/img/axis/S0000-cfe8b84c9133cd502578749b80fadb7b.png";